import axios from "axios";
import { VolumeDataEntry } from "../../interfaces/interfaces";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export async function getTankLevelsBySiteAndDate(siteName: string, fromDate: Date) {
    // API request to get Tank levels by site and date
    const params = new URLSearchParams();
    params.append("siteName", siteName);
    params.append("fromDate", fromDate.toISOString());

    try {
        const res = await axios.get(`${API_BASE_URL}/tank-levels-by-site-and-date`, {
            params
        });
        
        return res.data;

    } catch (err: any) {
        return "Failed to fetch dataset";
    }
}

export async function runPeakValleyAnalysis(receiveData: VolumeDataEntry[], tankCode: string) {
    // Run peak valley analysis and return results

    const body = {"tank_code": tankCode, "data": receiveData}

    try {
        const res = await axios.post(`${API_BASE_URL}/receive-peak-valley-analysis`, body);
        
        return res.data;

    } catch (err: any) {
        return "Failed to run analysis";
    }
}